import React from 'react'
import { HeaderView } from '@merchant-backend/common-components'

export default ({ title = '找不到该页面啦', children }) => (
  <HeaderView>
    <div className="center text-center">
      <h2>{title}</h2>
      {children}
    </div>
  </HeaderView>
)
